/* snoot: Gift Tiles. Copies Sugar's own gift tile twice (free bottle, perk tile), strips everything that
   would add it to the cart, and keeps both in step with the selected offer card.
   Perk tile: 90-Day Guarantee on 1 bottle; Free Shipping + Guarantee once the offer reaches the unlock tier. */
(function () {
  var TRUCK_PATH = 'M3 5h11v3h3.5L21 12v4h-2a2.5 2.5 0 0 1-5 0H9a2.5 2.5 0 0 1-5 0H3V5Zm14 5v2h2.4l-1.2-2H17ZM6.5 15.3a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4Zm10 0a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4Z';
  var SHIELD_PATH = 'M12 2 4 5v6c0 5 3.4 9.4 8 11 4.6-1.6 8-6 8-11V5l-8-3Z';
  var TICK_PATH = 'm8.4 12.2 2.4 2.4 4.9-5';
  var GUARD = '<div class="sgx-ship sgx-ship--guard"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + SHIELD_PATH + '"/><path class="sgx-tick" d="' + TICK_PATH + '"/></svg></div>';
  var COMBO = '<div class="sgx-ship sgx-ship--combo"><svg viewBox="0 0 24 24" aria-hidden="true"><g transform="translate(0 0.6) scale(0.86)"><path d="' + TRUCK_PATH + '"/></g><g transform="translate(11.6 10.4) scale(0.56)"><path class="sgx-ring" d="' + SHIELD_PATH + '"/><path class="sgx-tick" d="' + TICK_PATH + '"/></g></svg></div>';
  var STRIP = /^data-(gift-unlock|variant-id|product-id|required-quantity|unlock-mode|unlock-value|gift-price|price-template|locked-template|_sf|shopify-editor-block|gift-price-text|gift-locked-text)$/;

  function init(cfg) {
    if (cfg.__done) return;
    var sec = cfg.closest('.shopify-section') || document;
    var root = cfg.parentElement;
    while (root && !root.querySelector('.sugar-gift-unlocks__items .sugar-gift-unlock')) root = root.parentElement;
    if (!root) return;
    var grid = root.querySelector('.sugar-gift-unlocks__items');
    var src = grid && grid.querySelector('.sugar-gift-unlock:not([data-sgx-tile])');
    if (!src) return;
    cfg.__done = true;
    var d = cfg.dataset;
    var tiers = (d.tiers || '1,3,5').split(',').map(function (n) { return parseInt(n, 10) || 1; });
    var unlock = +d.unlock || 3, dbl = +d.double || 5;

    function mk() {
      var t = src.cloneNode(true);
      t.setAttribute('data-sgx-tile', '');
      [t].concat([].slice.call(t.querySelectorAll('*'))).forEach(function (el) {
        [].slice.call(el.attributes).forEach(function (a) { if (STRIP.test(a.name)) el.removeAttribute(a.name); });
      });
      var o = { t: t, on: t.querySelector('.sugar-gift-unlock__item--unlocked'), off: t.querySelector('.sugar-gift-unlock__item--locked'), name: t.querySelector('.sugar-gift-unlock__name') };
      o.img = o.on && o.on.querySelector('img');
      if (o.img) { o.img.removeAttribute('srcset'); o.img.removeAttribute('sizes'); }
      var above = o.off && o.off.querySelector('.sugar-gift-unlock__lock-above');
      if (above) above.remove();
      var below = o.off && o.off.querySelector('.sugar-gift-unlock__lock-below');
      if (below) below.textContent = d.locked;
      o.box = o.on && o.on.querySelector('.sugar-gift-unlock__image');
      o.price = function (v) { [].slice.call(t.querySelectorAll('.sugar-gift-unlock__price')).forEach(function (p) { p.textContent = v || ''; }); };
      o.state = function (open) { t.setAttribute('data-unlocked', open ? 'true' : 'false'); };
      return o;
    }
    var bottle = mk(), perk = d.showShip === 'true' ? mk() : null;
    if (bottle.img) bottle.img.alt = d.name1;
    if (perk) {
      perk.state(true);
      grid.insertBefore(perk.t, grid.firstChild);
    }
    grid.insertBefore(bottle.t, grid.firstChild);

    function count() {
      var list = root.querySelector('.sugar-offer-list') || sec;
      var all = [].slice.call(list.querySelectorAll('.sugar-offer'));
      var i = all.indexOf(list.querySelector('.sugar-offer.is-selected'));
      return tiers[i < 0 ? Math.min(1, tiers.length - 1) : i] || tiers[0];
    }
    var perkMode = '';
    function paint() {
      var b = count(), two = b >= dbl, open = b >= unlock;
      bottle.state(open);
      if (open && bottle.img) bottle.img.src = two ? d.b2 : d.b1;
      bottle.price(two ? d.price2 : d.price1);
      if (bottle.name) bottle.name.innerHTML = '<strong>' + (two ? d.name2 : d.name1) + '</strong>';
      if (perk) {
        var mode = open ? 'combo' : 'guard';
        if (mode !== perkMode) {
          perkMode = mode;
          if (perk.box) perk.box.innerHTML = open ? COMBO : GUARD;
          perk.price(open ? d.shipPrice : d.guardPrice);
          if (perk.name) perk.name.innerHTML = '<strong>' + (open ? d.ship : d.guard) + '</strong>';
        }
      }
    }
    paint();
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) if (ms[i].target.matches && ms[i].target.matches('.sugar-offer')) { paint(); return; }
    }).observe(sec, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-snoot-gift-tiles]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
